import { useEffect, useState } from 'react';

import type { TimeBreakdownStrings } from './types';
import {
  castTimeBreakdownStrings,
  getTimeBreakdownStrings,
  getTotalSeconds,
} from './utils';

export const useDurationPickerField = (
  persistValue: (newTotalSeconds: number) => void,
  totalSeconds?: number | null
) => {
  const [breakdown, setBreakdown] = useState<TimeBreakdownStrings>(
    getTimeBreakdownStrings(totalSeconds)
  );

  // Sync internal state when totalSeconds prop changes
  useEffect(() => {
    setBreakdown(getTimeBreakdownStrings(totalSeconds));
  }, [totalSeconds]);

  const handleBlur = () => {
    const newTotalSeconds = getTotalSeconds(
      castTimeBreakdownStrings(breakdown)
    );
    if (newTotalSeconds === totalSeconds) return;
    persistValue(newTotalSeconds);
  };
  const handleUpdateTime = (patch: Partial<TimeBreakdownStrings>) => {
    setBreakdown((prev) => ({ ...prev, ...patch }));
  };

  return { breakdown, handleBlur, handleUpdateTime };
};
